<template>
  <label id="map-sidebar-checkbox-label" class="ow-map-button" for="map-sidebar-checkbox">
    <span class="os-icon icon-filter"></span>
  </label>
  <input id="map-sidebar-checkbox" v-model="mapSidebarExpanded" type="checkbox">
  <aside class="ow-map-sidebar" :class="{ 'is-disabled': isDisabled }">
    <h3 class="ow-map-sidebar-header-container">
      <div class="ow-map-sidebar-header">
        Find your screening centre using:
      </div>
    </h3>

    <div class="ow-map-sidebar-radio-wrapper" :class="{ 'is-disabled': isLiveLocationDisabled }">
      <input id="live-location-radio"
        v-model="screeningCenterLookupMethod"
        class="ow-map-sidebar-radio-input"
        type="radio"
        value="live"
        name="live-location-radio"
        @change="screeningCenterLookupMethodUpdated($event, 'live', true, 0)"
        >
      <label for="live-location-radio" class="ow-map-sidebar-radio-label">
        <div class="ow-map-sidebar-radio-circle"></div>
        <div class="ow-map-sidebar-radio-text">Your current location</div>
        <select id="ow-range-select"
          v-model="range"
          name=""
          @change="screeningCenterLookupMethodUpdated($event, 'live', true, 0)"
          >
          <option value="5">5km</option>
          <option value="10">10km</option>
          <option value="15">15km</option>
          <option value="20">20km</option>
          <option value="25">25km</option>
          <option value="30">30km</option>
        </select>
      </label>
    </div>

    <div class="ow-map-sidebar-input-wrapper">
      <input id="area-code-input"
        v-model="zipCodeValue"
        type="text"
        class="ow-map-sidebar-text-input area-code oxia-input"
        name="area-code-input"
        placeholder="Area code"
        @input="screeningCenterLookupMethodUpdated($event, 'areaCode', true, 2500)"
        >
    </div>

    <div class="ow-map-sidebar-input-wrapper">
      <input id="screening-center-name-input"
        v-model="screeningCenterSearchValue"
        type="search"
        class="ow-map-sidebar-text-input screening-center oxia-input"
        minlength="3"
        name="screening-center-input"
        placeholder="Clinic name (min. 3 characters)"
        @input="screeningCenterLookupMethodUpdated($event, 'screeningCenter', false, 2500)"
        >
    </div>

    <div v-if="areFiltersVisible" class="ow-sidebar-options-container">
      <div class="ow-map-sidebar-header-container mb-4 mt-1">
        <h3 class="ow-map-sidebar-header">
          SCREENING CENTRES NEAR YOU
        </h3>
        <h5 class="ow-map-sidebar-subheader">
          You can make your booking by clicking on the screening centre of your choice on the map
        </h5>
      </div>
      <!-- <ScreeningCenterFilters v-model="selectedFilters" :options="screeningCenterFilterOptions" /> -->
      <!-- <div class="ow-map-sidebar-header-container mt-3">
        <h5 class="ow-map-sidebar-subheader">
          Please note there is no price difference between screening centre types.
        </h5>
      </div> -->
    </div>
    <div v-else-if="isListVisible" class="ow-sidebar-screening-centers-list-wrapper">
      <p style="font-size: 13px; padding: 10px; margin: 0; margin-bottom: 10px; margin-inline: 5px;">
        Click on a screening center to locate it on the map
      </p>
      <ul class="ow-screening-center-filters screening-centers-list">
        <li v-for="screeningCenter in screeningCenters"
          :key="screeningCenter._id"
          class="ow-screening-center-filters-option screening-center-option"
          @click="screeningCenterClicked(screeningCenter)"
          >
          {{ screeningCenter.name }}
        </li>
      </ul>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

// import type { IScreeningCenterFilterOption } from './ScreeningCenterFilterOption.vue';
// import ScreeningCenterFilters from './ScreeningCenterFilters.vue';

interface IMapSidebarProps {
  isDisabled: boolean
  isLiveLocationDisabled: boolean
  screeningCenters: ISubOrganization[]
}

const props = defineProps<IMapSidebarProps>();

const emit = defineEmits(['screeningCenterClicked', 'lookupMethodUpdated']);

const mapSidebarExpanded = ref(false);

const screeningCenterLookupMethod = ref('live');
const range = ref('5');
const zipCodeValue = ref();
const screeningCenterSearchValue = ref('');

// FILTERS ARE DISABLED FOR NOW UNTIL WE DECIDE TO ALSO SPECIALIST SC
// const selectedFilters = defineModel<string[]>({ default: [], type: Array });
// const screeningCenterFilterOptions = ref<IScreeningCenterFilterOption[]>([
// {
//   name: 'medical-screening-center',
//   text: 'Medical',
//   icon: '/images/IconMed.png',
//   cardTitle: 'Medical Centre SC',
//   cardText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod lacinia lectus, ut ultricies ipsum tempus id. Nulla facilisi. Sed pulvinar, nunc at pharetra condimentum, ipsum metus euismod velit,'
// },
// {
//   name: 'optometrist-screening-center',
//   text: 'Optometrist',
//   icon: '/images/IconOp.png',
//   cardTitle: 'Optometrist SC',
//   cardText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod lacinia lectus, ut ultricies ipsum tempus id. Nulla facilisi. Sed pulvinar, nunc at pharetra condimentum, ipsum metus euismod velit,'
// },
// {
//   name: 'specialist-screening-center',
//   text: 'Specialist',
//   icon: '/images/IconSp.png',
//   cardTitle: 'Specialist SC',
//   cardText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod lacinia lectus, ut ultricies ipsum tempus id. Nulla facilisi. Sed pulvinar, nunc at pharetra condimentum, ipsum metus euismod velit,'
// },
// {
//   name: 'pathcare-screening-center',
//   text: 'Pathcare',
//   icon: '/images/IconPc.png',
//   cardTitle: 'Pathcare SC',
//   cardText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod lacinia lectus, ut ultricies ipsum tempus id. Nulla facilisi. Sed pulvinar, nunc at pharetra condimentum, ipsum metus euismod velit,'
// },
// {
//   name: 'pharmacy-screening-center',
//   text: 'Pharmacy',
//   icon: '/images/IconPh.png',
//   cardTitle: 'Pharmacy SC',
//   cardText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod lacinia lectus, ut ultricies ipsum tempus id. Nulla facilisi. Sed pulvinar, nunc at pharetra condimentum, ipsum metus euismod velit,'
// },
// {
//   name: 'referring-doctor-screening-center',
//   text: 'General Practitioner',
//   icon: '/images/IconRd.png',
//   cardTitle: 'General Practitioner SC',
//   cardText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod lacinia lectus, ut ultricies ipsum tempus id. Nulla facilisi. Sed pulvinar, nunc at pharetra condimentum, ipsum metus euismod velit,'
// }
// ]);

const areFiltersVisible = computed(() => {
  return screeningCenterLookupMethod.value === 'live' || screeningCenterLookupMethod.value === 'areaCode';
});

const isListVisible = computed(() => {
  return screeningCenterLookupMethod.value === 'screeningCenter' && props.screeningCenters;
});

// Used to delay the callback function until the timer runs out / user stops typing
function debounce(func: (...args) => void) {
  let timeoutId: Timeout;
  return (...args: any[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
      // args.pop as the timeout because everytime we call we will be using the last parameter as the timeout.
      // This is a hack to have dynamic debounce based on debounced function call
    }, args.pop() || 0);
  };
}

const resetValues = (newMethod: string) => {
  switch (newMethod) {
    case 'live':
      zipCodeValue.value = '';
      screeningCenterSearchValue.value = '';
      break;
    case 'areaCode':
      range.value = '5';
      screeningCenterSearchValue.value = '';
      break;
    case 'screeningCenter':
      zipCodeValue.value = '';
      range.value = '5';
      break;
  }
};

const screeningCenterClicked = (screeningCenter: ISubOrganization) => {
  emit('screeningCenterClicked', screeningCenter.geoLocation, screeningCenter);
  resetValues('screeningCenter');
};

const screeningCenterLookupMethodUpdated = debounce((event: Event | InputEvent, method: string, collapseSidebar?: boolean, timeout?: number) => {
  const value = event?.target?.value;
  if ((method === 'screeningCenter' && value && value.length >= 3) || (method && method !== 'screeningCenter')) {
    screeningCenterLookupMethod.value = method;
    emit('lookupMethodUpdated', method, value);
    resetValues(method);
    if (collapseSidebar) mapSidebarExpanded.value = false;
  }
});
</script>

<style lang='scss'>
.ow-map-sidebar {
  display: flex;
  flex-direction: column;
  text-align: center;
  flex: 0 1 20%;
  height: 100%;
  padding: 15px;
  gap: 15px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 2px 0px 5px -5px #000000f1;
  z-index: 1;
  transition: transform 0.3s ease;
  height: 100%;
  background-color: #fff;
   &.is-disabled {
    opacity: 0.5;
    user-select: none;
    cursor: not-allowed;
    pointer-events: none;
  }
  & .ow-map-sidebar-header-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    & .ow-map-sidebar-header {
      font-size: clamp(0.9rem, 2vw, 0.9rem);
      font-weight: 700;
      text-transform: uppercase;
      margin: 0;
    }
    & .ow-map-sidebar-subheader {
      font-size: clamp(0.9rem, 2vw, 0.9rem);
      font-weight: 500;
      margin: 0;
      text-align: center;
    }

  }

  & .ow-map-sidebar-radio-wrapper {
    display: flex;
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    align-items: center;
    &.is-disabled {
      transition: opacity ease-in 0.5s;
      opacity: 0.5;
      /* Optional: Adjust opacity to visually indicate the disabled state */
      color: rgb(199, 188, 188);
      pointer-events: none;
    }
    & .ow-map-sidebar-radio-input {
      display: none;
      &:checked {
        & + .ow-map-sidebar-radio-label {
          & .ow-map-sidebar-radio-circle {
            background-color: #0c3555;
            box-shadow: inset 0 0 0 3px #fff;
          }
        }
      }
    }
    & .ow-map-sidebar-radio-label {
      display: flex;
      align-items: center;
      gap: 10px;
      padding-left: 5px;
      & .ow-map-sidebar-radio-circle {
        flex: 0 0 15px;
        height: 15px;
        border-radius: 20px;
        border: 1px solid #0c3555;
        background-color: #ffffff;
      }
    }
  }

  & .ow-map-sidebar-input-wrapper {
    & .ow-map-sidebar-text-input {
      color: #0c3555;
      &.area-code {
        padding-left: 25px;
        background-image: url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-map-pin'><path d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z'></path><circle cx='12' cy='10' r='3'></circle></svg>");
        background-repeat: no-repeat;
        background-size: 15px 15px;
        background-position: 5px center;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
      }
      &.screening-center {
        padding-left: 25px;
        background-image: url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-search'><circle cx='11' cy='11' r='8'></circle><line x1='21' y1='21' x2='16.65' y2='16.65'></line></svg>");
        background-repeat: no-repeat;
        background-size: 15px 15px;
        background-position: 5px center;
      }
    }
  }

}
#ow-range-select {
  border-radius: 6px;
  padding: 3px 5px;
  &::picker(select) {
    border-radius: 6px;
  }
  & option {
    display: flex;
    justify-content: flex-start;
    gap: 20px;

    border: 2px solid #dddddd;
    background: #eeeeee;
    padding: 10px;
    transition: 0.4s;
    &:first-of-type {
      border-radius: 6px 6px 0 0;
    }
    &:last-of-type {
      border-radius: 0 0 6px 6px;
    }
    &:not(option:last-of-type) {
      border-bottom: none;
    }
  }
}
.ow-sidebar-screening-centers-list-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  & .screening-centers-list {
    gap: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 15px 15px;
    flex: 1 1 100%;
    & .screening-center-option {
      box-shadow: 2px 2px 5px -1px #c4c4c4;
      padding: 10px;
    }
  }
}
</style>
